const pageScrollState = (() => {
    const root = document.documentElement; // <html>
    const body = document.body;


    let lockCount = 0; // nested locks support (modals stacking, etc.)
    let scrollY = 0; // stored scroll position
    let paddingApplied = 0; // last applied scrollbar compensation


    const getScrollbarWidth = () => Math.max(0, window.innerWidth - root.clientWidth);

    // When `scrollbar-gutter: stable` is active the gutter is always reserved,
    // so locking overflow does not change layout width — adding padding would
    // double-compensate and cause a visible jump.
    const hasStableGutter = () => {
        const gutter = getComputedStyle(root).scrollbarGutter || '';
        return gutter.includes('stable');
    };


    const applyLock = () => {
        scrollY = window.scrollY || window.pageYOffset || 0;
        const sw = hasStableGutter() ? 0 : getScrollbarWidth();
        paddingApplied = sw;


        root.classList.add('fixed'); // CSS must set overflow:hidden on <html>
        if (sw) body.style.paddingRight = `${sw}px`; // compensate layout shift on body
    };


    const removeLock = () => {
        root.classList.remove('fixed');
        if (paddingApplied) body.style.paddingRight = '';
        window.scrollTo(0, scrollY);
        paddingApplied = 0;
    };


    const fix = () => { if (lockCount++ === 0) applyLock(); };
    const unfix = () => { if (lockCount === 0) return; if (--lockCount === 0) removeLock(); };
    const toggle = () => (root.classList.contains('fixed') ? unfix() : fix());
    const set = (position) => { window.scrollTo(0, position); };
    const isFixed = () => root.classList.contains('fixed');


    return { fix, unfix, toggle, set, isFixed };
})();


export default pageScrollState;


/* ===================== HOW TO USE =====================
// JS:
// import pageScrollState from '../lib/page-scroll-state';
// pageScrollState.fix(); // lock scroll (adds html.fixed, compensates body padding)
// pageScrollState.unfix(); // unlock (restores position, removes padding)
// pageScrollState.toggle(); // toggle
// pageScrollState.isFixed(); // boolean
// pageScrollState.set(0); // scroll to top when needed
*/
